var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3931 1.39422H11.6185V0H10.0694V1.39422H3.87283V0H2.3237V1.39422H1.54913C0.689364 1.39422 0.00774566 2.02162 0.00774566 2.78844L0 12.548C0 13.3148 0.689364 13.9422 1.54913 13.9422H12.3931C13.2451 13.9422 13.9422 13.3148 13.9422 12.548V2.78844C13.9422 2.02162 13.2451 1.39422 12.3931 1.39422ZM12.3931 12.548H1.54913V4.87977H12.3931V12.548ZM3.09827 6.27399H6.9711V9.75953H3.09827V6.27399Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminCalendarIcon);
export default __webpack_public_path__ + "static/media/AdminCalendarIcon.5e40c79a5aba104a6fb49fdc486f5967.svg";
export { ForwardRef as ReactComponent };